var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTivraLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 145.2 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #2d68fe;\n      }\n\n      .st2 {\n        fill: #324054;\n      }\n\n      .st3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 20,
    y: 8,
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.3,18.7v10.7l-10.7,10.7v-21.3h-10.7v-10.7h10.7l10.7,10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52,8l-10.7,10.7v-10.7h10.7Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.4,14.7v3.1h-5.2v14.2h-3.6v-14.2h-5.2v-3.1h14ZM83.2,19.2v12.8h-3.4v-12.8h3.4ZM83.2,14.6v3.1h-3.4v-3.1h3.4ZM85.2,19.2h3.8l2.7,9.4,2.7-9.4h3.6l-4.6,12.8h-3.5l-4.6-12.8ZM106.3,22.3c-1.3,0-2.2.4-2.7,1.3-.3.5-.4,1.2-.4,2.3v6.1h-3.4v-12.8h3.2v2.2c.5-.9,1-1.4,1.3-1.7.6-.5,1.4-.8,2.4-.8s.1,0,.2,0c0,0,.1,0,.3,0v3.4c-.2,0-.4,0-.6,0-.2,0-.3,0-.4,0ZM109.7,20.6c.9-1.1,2.4-1.7,4.5-1.7s2.6.3,3.7.8c1.1.6,1.6,1.6,1.6,3.1v5.9c0,.4,0,.9,0,1.5,0,.4,0,.7.2.9.1.2.3.3.5.4v.5h-3.6c-.1-.3-.2-.5-.2-.7,0-.2,0-.5,0-.8-.5.5-1,.9-1.6,1.3-.7.4-1.5.6-2.4.6s-2.1-.3-2.9-1c-.8-.7-1.1-1.6-1.1-2.8s.6-2.7,1.8-3.4c.7-.4,1.6-.7,2.9-.8h1.1c.6-.2,1.1-.3,1.3-.4.5-.2.7-.5.7-.9s-.2-.9-.6-1.1c-.4-.2-.9-.3-1.6-.3s-1.3.2-1.7.6c-.2.3-.4.7-.5,1.2h-3.2c0-1.1.4-2,.9-2.8ZM112.2,29.6c.3.3.7.4,1.1.4.7,0,1.4-.2,2-.6.6-.4.9-1.2.9-2.3v-1.2c-.2.1-.4.2-.6.3-.2,0-.5.2-.9.2h-.8c-.7.3-1.2.4-1.5.6-.5.3-.8.8-.8,1.4s.2,1,.5,1.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTivraLogo);
export default __webpack_public_path__ + "static/media/tivra_logo.7cabd9620f34a6aa803a767391d5e486.svg";
export { ForwardRef as ReactComponent };